/* Colours for things drawn outside CSS (Leaflet canvas, SVG overlays), which
   can't read custom properties. Keep in step with tokens.css. Condition line
   colours are a shade brighter than the text tokens so thin map lines read. */
export const COLORS = {
  navy: "#0b416c",
  navyInk: "#072a45",
  accent: "#0a6fd1",
  good: "#18864a",
  fairLine: "#d38b00",
  fair: "#a86a00",
  poor: "#c22f36",
  unratedLine: "#6f8aa3",
  boxVerified: "#ff4d4f",
  boxUnreviewed: "#ffc247",
} as const;

export const CONDITION_COLOR: Record<string, string> = {
  Good: COLORS.good,
  Fair: COLORS.fairLine,
  Poor: COLORS.poor,
  "Not rated": COLORS.unratedLine,
};

export const DOMAIN_COLOR: Record<string, string> = {
  condition: COLORS.poor,
  assets: COLORS.accent,
  safety: COLORS.fair,
};
